import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19b14450")

_pushScopeId("data-v-19b14450")
const _hoisted_1 = { class: "RepairItemAddPopup__items-container" }
const _hoisted_2 = { class: "RepairItemAddPopup__items-container-inner" }
const _hoisted_3 = { class: "RepairItemAddPopup__items-text" }
const _hoisted_4 = { class: "RepairItemAddPopup__textarea-container" }
const _hoisted_5 = { class: "RepairItemAddPopup__button-container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("완료")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Check = _resolveComponent("Check")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_Button = _resolveComponent("Button")
  const _component_FullscreenPopup = _resolveComponent("FullscreenPopup")

  return (_openBlock(), _createBlock(_component_FullscreenPopup, {
    class: "RepairItemAddPopup",
    title: "수리항목 추가",
    onClose: _cache[3] || (_cache[3] = $event => (_ctx.$emit('close')))
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Accordion, {
            class: "RepairItemAddPopup__items",
            data: _ctx.sections,
            onItemClick: _ctx.onItemClick
          }, {
            default: _withId((scope) => [
              _createVNode(_component_Check, {
                done: 
                () =>
                  _ctx.onItemClick({
                    section: scope.section,
                    item: scope.data,
                  })
              ,
                checked: scope.data.checked
              }, null, 8, ["done", "checked"]),
              _createVNode("div", _hoisted_3, _toDisplayString(scope.data.text), 1)
            ]),
            footer: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.manualInputText = $event)),
                  ref: "textarea",
                  class: "RepairItemAddPopup__textarea",
                  placeholder: "수리 항목을 직접 입력해주세요.",
                  onInput: _cache[2] || (_cache[2] = (...args) => (_ctx.onTextareaResize(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.manualInputText]
                ])
              ])
            ]),
            _: 1
          }, 8, ["data", "onItemClick"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "RepairItemAddPopup__button",
          color: _ctx.ButtonThemeStyle.PRIMARY,
          size: _ctx.ButtonSizeStyle.H50,
          onClick: _ctx.onRepairItemAddApplyButtonClick
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["color", "size", "onClick"])
      ])
    ]),
    _: 1
  }))
})